// extracted by mini-css-extract-plugin
export var colorSquare = "_tc-0";
export var danger = "_tc-5";
export var lightPink = "_tc-8";
export var neutralBlue = "_tc-7";
export var neutralYellow = "_tc-6";
export var normal = "_tc-1";
export var primary = "_tc-2";
export var primaryLight = "_tc-3";
export var solidBlack = "_tc-g";
export var solidGreen = "_tc-b";
export var solidLightBlue = "_tc-d";
export var solidNavy = "_tc-c";
export var solidOrange = "_tc-f";
export var solidPink = "_tc-e";
export var solidRed = "_tc-9";
export var solidYellow = "_tc-a";
export var success = "_tc-4";